const buildListFilter = (
  field: string,
  value: any[],
  operator: string
): string => {
  const list = value.map((elem) => `${field}:${operator}${elem}`)
  return list.join(';')
}

function isEmpty(value: any): boolean {
  return !value || value === ''
}

const operators: Record<string, string> = {
  withoutInstruments: '!=',
  withInstruments: '=',
  nationalities: '=',
  birthCountry: '=',
  deathCountry: '=',
}

function isList(field: string): boolean {
  return Object.keys(operators).includes(field)
}

function getChildrenIds(genres, value) {
  for (const genre of genres) {
    if (genre.id === value) {
      return [value, ...genre.children.map((child) => child.id)]
    }
    if (genre.children.length > 0) {
      const result = getChildrenIds(genre.children, value)
      if (result.length > 0) {
        return [value, ...result]
      }
    }
  }
  return [value]
}

export async function buildFilters(
  formValues: {
    [key: string]: any
  },
  genresList
): Promise<string> {
  let filters = ''

  for (const [field, value] of Object.entries(formValues)) {
    if (isEmpty(value)) {
      continue
    }

    if (typeof value === 'object' && 'minValue' in value) {
      if (isEmpty(value.minValue) && isEmpty(value.maxValue)) {
        continue
      }
      if (!value.range && isEmpty(value.minValue)) {
        continue
      }
      if (value.range && !isEmpty(value.minValue) && !isEmpty(value.maxValue)) {
        filters += `(${field}:[${value.minValue}..${value.maxValue}])`
      } else if (!value.range && !isEmpty(value.minValue)) {
        filters += `(${field}:${value.minValue})`
      } else if (!isEmpty(value.minValue)) {
        filters += `(${field}:>${value.minValue})`
      } else {
        filters += `(${field}:<${value.maxValue})`
      }
      filters += ';'
    } else if (isList(field)) {
      if (!value || value?.length === 0) {
        continue
      }
      filters += `(${buildListFilter(field, value, operators[field])})`
      filters += ';'
    } else {
      if (field === 'genres') {
        const genres = [value]
        // if (genresList) {
        //   genres = getChildrenIds(genresList, value)
        // }
        filters += `${field}:=[${genres.join(',')}]`
        filters += ';'
      } else {
        filters += `${field}:${value}`
        filters += ';'
      }
    }
  }
  filters = filters.replace(/;+$/, '')
  return filters
}
